import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const JobPaymentCancel = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const jobId = searchParams.get('jobId');
  const reference = searchParams.get('reference');

  useEffect(() => {
    // Redirect to job page after 3 seconds
    const timer = setTimeout(() => {
      if (jobId) {
        navigate(`/jobs/${jobId}?payment=cancelled`);
      } else {
        navigate('/');
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, [jobId, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-6 text-center">
        <XCircle className="mx-auto h-12 w-12 text-red-500 mb-4" />
        <h1 className="text-xl font-semibold text-gray-900 mb-2">Payment Cancelled</h1>
        <p className="text-gray-600 mb-4">
          Your payment has been cancelled. No charges were made to your account.
        </p>
        
        <div className="text-sm text-gray-500 mb-4">
          {jobId && <p>Job ID: {jobId}</p>}
          {reference && <p>Reference: {reference}</p>}
        </div>
        
        <div className="space-y-2">
          <button
            onClick={() => jobId ? navigate(`/jobs/${jobId}`) : navigate('/')}
            className="w-full bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700"
          >
            {jobId ? 'Return to Job' : 'Go Home'}
          </button>
          
          <p className="text-sm text-gray-600">
            Redirecting you back in 3 seconds...
          </p>
        </div>
      </div>
    </div>
  );
};

export default JobPaymentCancel;